<div class="container" [class.has-title]="showTitle && !!config.title" [class.compact]="compact">
  <label *ngIf="showTitle && config.title" class="input-title">{{ config.title }}</label>

  <mat-form-field appearance="outline">
    <mat-label *ngIf="config.label">{{ config.label }}</mat-label>
    <mat-select
      [formControl]="control"
      [placeholder]="config.placeholder || ''"
      [attr.aria-label]="config.title || config.label || config.controlName"
      (selectionChange)="selectionChange.emit($event.value)"
      (blur)="onTouched()"
    >
      <mat-option *ngIf="searchControl">
        <ngx-mat-select-search
          [formControl]="searchControl"
          [clearSearchInput]="true"
          [placeholderLabel]="searchPlaceholder"
          [noEntriesFoundLabel]="noEntriesFoundLabel"
          [enableClearOnEscapePressed]="true"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let option of (config.options$ ? (config.options$ | async) ?? [] : options); trackBy: trackByOption"
        [value]="option.value"
        [disabled]="option.disabled"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>

    <button
      *ngIf="config.icons?.clear && hasValue"
      class="select-clear"
      matSuffix
      type="button"
      [disabled]="control.disabled"
      [attr.aria-label]="config.icons?.clearAriaLabel || 'Limpar seleção'"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
      (click)="clear($event)"
    >
      <mat-icon aria-hidden="true">{{ config.icons?.clear }}</mat-icon>
    </button>

    <mat-error *ngIf="control.touched && control.hasError('required')">
      Campo obrigatório.
    </mat-error>
  </mat-form-field>
</div>
